import moment from 'moment';

/**
 * Returns current datetime in YYYY-MM-DD HH:mm:ss format
 */
export const dtNow = (): string => {
  const customFormat = 'YYYY-MM-DD HH:mm:ss';
  return moment().format(customFormat);
};

/**
 * Returns current Unix timestamp in seconds
 */
export const unixTsNow = (): number => {
  return Math.floor(Date.now() / 1000);
};

/**
 * Converts Unix timestamp (seconds) to YYYY-MM-DD HH:mm:ss format
 * @param unixTs - Unix timestamp in seconds
 */
export const unixTsToFormatted = (unixTs?: number | null): string => {
  if (unixTs == null || Number.isNaN(unixTs)) return '';
  const customFormat = 'YYYY-MM-DD HH:mm:ss';
  return moment.unix(unixTs).format(customFormat);
};
